import { Injectable } from '@angular/core';
import { DataService } from '../../shared-service/data.service';
import { BaseService } from '../../shared-service/base.service';

declare var jquery:any;
declare var $ :any;

@Injectable()
export class SuggestionsService {

	constructor(private dataService: DataService, private bs: BaseService) {
		this.bs.log('info', "Loaded suggestions Service");
	}

    initCorousals(corousalClass: any, navgation: any) {
		var owl = $('.'+ corousalClass);
	    owl.owlCarousel({
	        nav: navgation,
			margin:10,
	        loop: false,
	        items:1,
	        navRewind: false
	    });
	}
}